import { AxiosResponse } from 'axios'
import { IExternalReviewsResponse, ISurveyStatusResponse } from './../model/types'
import api from '~/services/api'

export const externalReviews = async (id: number) => {
  const res: AxiosResponse<IExternalReviewsResponse> = await api.get(`shop/${id}/external-reviews`)
  return res.data.result
}

export const bannerClick = async (code: string, id: number) => {
  await api.post('banner/click', { code, id })
}

export const bannerTransition = async (code: string, id: number) => {
  await api.post('banner/transition', { code, id })
}

/**
 * Получение статуса опроса для магазина
 * @param shopId - ID магазина
 * @returns Promise с результатом проверки статуса
 */
export const getSurveyStatus = async (shopId: number): Promise<ISurveyStatusResponse> => {
  const { data }: AxiosResponse<ISurveyStatusResponse> = await api.get(`/survey/status/${shopId}`)
  return data
}
